// extracted by mini-css-extract-plugin
export default {"container":"ListPlaceholderProject_container__t-7Sr","textLine":"ListPlaceholderProject_textLine__8DW3w","imgArrow":"ListPlaceholderProject_imgArrow__0Ne3O"};